import { render, staticRenderFns } from "./ProductDatasheet.vue?vue&type=template&id=6c14c154"
import script from "./ProductDatasheet.vue?vue&type=script&lang=js"
export * from "./ProductDatasheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports